var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 13", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { transform: "translate(0 -1)", className: styles["clear-input-fill"] || "clear-input-fill", fill: "#D8D8D8", fillRule: "nonzero" },
      React.createElement("rect", { transform: "rotate(45 7 7.5)", x: "6", y: "-1", width: "2", height: "17", rx: "1" }),
      React.createElement("rect", { transform: "scale(-1 1) rotate(45 0 -9.4)", x: "6", y: "-1", width: "2", height: "17", rx: "1" })
    )
  );
});